module.exports = __webpack_public_path__ + "img/form_steps_icon_step.023c1e15.svg";